import React from 'react'
import Banner from "./Banner";
import Features from './Features';
import Categorys from './Categorys';
import AboutSkinOra from './AboutSkinOra';
import Products from './Products';
import CustomerTestimonials from './CustomerTestimonials';

export default function Home() {
  return (
    <>
      <Banner />
      <Features />
      <Categorys />
      <AboutSkinOra />
      <Products />
      <CustomerTestimonials />
    </>
  );
}

